import { Routes } from '@angular/router';

/**
 * components
 */
import { NotFoundComponent } from '@systemModule/components';

/**
 * consts
 */
import { AppRoutesConst } from './app-routes-const';

export const routes: Routes = [
    {
        path: "",
        loadChildren: () => import('@core/content-layout/content-layout.routes')
        .then(r => r.ContentLayoutRoutes),
    },
    /**
     * Named counterpart to the wildcard below, so a page that resolves its own "this does not
     * exist" (e.g. the Schedule edit wizard failing to load its `:id`) can navigate here
     * explicitly instead of relying on a URL that happens to match nothing.
     */
    { path: AppRoutesConst.NOT_FOUND_ROUTE_PAGE, component: NotFoundComponent },
    { path: "**", component: NotFoundComponent, pathMatch: 'full' }
];
